<template>
  <a-drawer
    class="part drawer pm-contract"
    width="700"
    title="New Contract"
    placement="right"
    :closable="true"
    :visible="visible"
    :after-visible-change="afterVisibleChange"
    @close="onClose"
  >
    <div class="inner">
      <ContractForm @submit="onSubmit" />
    </div>
  </a-drawer>
</template>
<script>
import { ContractForm } from '@/components/reno/forms'

const KEY = 'CREATE_CONTRACT'

export default {
  components: {
    ContractForm,
  },
  name: 'pm-contract-drawer',
  data() {
    return {}
  },
  computed: {
    visible: {
      get() {
        return this.$store.getters['pm/UI_VISIBLE'](KEY)
      },
      set(visible) {
        this.$store.dispatch('pm/UI_VISIBLE', { key: KEY, visible })
      },
    },
  },
  methods: {
    async onSubmit(valid_contract) {
      if (valid_contract) {
        const new_contract = await this.$store.dispatch('pm/insertContract', valid_contract)
        this.visible = false
      }
    },
    afterVisibleChange(val) {
      // NOTHING
    },
    showDrawer() {
      this.visible = true
    },
    onClose() {
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer.pm-contract {
  .inner {
    max-width: 750px;
    margin: 0 auto;
  }
}
</style>
